import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Table,
  Label,
  FloatingLabel,
  InputGroup,
  Modal,
  Pagination,
} from "react-bootstrap";
import Center from "react-center";
import Select from "react-select";
import * as Icons from "react-feather";
import moment from "moment";
import Axios from "axios";
import { urlAPI, getUser, getToken } from "Common";
// import { urlAPI, getUser, getToken } from "utility/Common";
import CanvasStep1 from "./CanvasFilter";
//import DataTable from "react-data-table-component";
import Radio from "components/@vuexy/radio/RadioVuexy";
import TableSmall from "./component/TableSmallAntrian";
import TableLarge from "./component/TableLargeAntrian";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";


const initDataDokter = {
  count: 0,
  rows: [],
};
const initDataBooking = {
  NOBOOKING: "",
  PASIEN: null,
  FARMASI: null,
  RADIOLOGI: null,
  LABORATORIUM: null,
  TUJUAN: null,
  NAMAUNIT: null,
};

// const initParamRiwayat = {
//   norm: null,
//   tgllahir: null,
// };

const initParamPelanggan = {
  nama: null,
  norm: null,
  tgllahir: null,
};

const initPelangganRajal = {
  noreg: "",
  nama: "",
  unit: "",
  nokamar: "",
  notlp: "",
  no1: "",
  no2: "",
  no3: "",
  no4: "",
  no5: "",
  no6: "",
  no7: "",
  no8: "",
  no9: "",
  no10: "",
  no11: "",
  no12: "",
  promosi: "",
  keseluruhan: "",
  perawat: "",
  apkes: "",
  saran: "",
  konfirmasi: "",
};
const initPelangganRawin = {
  noreg: "",
  nama: "",
  unit: "",
  nokamar: "",
  notlp: "",
  no1: "",
  no2: "",
  no3: "",
  no4: "",
  no5: "",
  no6: "",
  no7: "",
  no8: "",
  no9: "",
  no10: "",
  no11: "",
  no12: "",
  no13: "",
  no14: "",
  no15: "",
  no16: "",
  no17: "",
  no18: "",
  no19: "",
  no20: "",
  no21: "",
  no22: "",
  no23: "",
  no24: "",
  no25: "",
  no26: "",
  no27: "",
  no28: "",
  lab: "",
  rad: "",
  perawat: "",
  apkes: "",
  saran: "",
  promosi: "",
  keseluruhan: "",
  konfirmasi: "",
};
const initReg = {
  noreg: "",
  jenis: "",
};
export default function PelangganSection(props) {
  const {
    filterAntrian,
    setFilterAntrian,
    selectorSBU,
    fetchSelectorUnitAntrian,
    selectorAntrian,
    loadingAntrian,
    setLoadingAntrian,
    setMessageState,
    setShowFailed,
    setShowInfo,
    source,
  } = props;
  console.log('source', source)
  const [dataTable, setDataTable] = useState({ count: 0, rows: [] });
  const [dataBooking, setDataBooking] = useState(initDataBooking);
  const [loadingLoad, setLoadingLoad] = useState(false);
  const [loadingCari, setLoadingCari] = useState(false);
  const [pilih, setPilih] = useState("antrian");
  const [openCanvas, setOpenCanvas] = useState(false);
  const [idbook, setIdBook] = useState(null);
  const [paramPelanggan, setParamPelanggan] = useState(initParamPelanggan);
  const [adaData, setAdaData] = useState(null);
  const [dataPelanggan, setDataPelanggan] = useState(null);
  const [statusIsi, setStatusIsi] = useState(null);
  const [dataPelangganRajal, setDataPelangganRajal] =
    useState(initPelangganRajal);
  const [dataPelangganRawin, setDataPelangganRawin] =
    useState(initPelangganRawin);
  const [selectorReg, setSelectorReg] = useState([]);
  const [loadingReg, setLoadingReg] = useState(false);
  const [noReg, setNoReg] = useState(initReg);
  const [adaKomplain, setAdaKomplain] = useState(" Tidak Ada");
  const [adaKomplainRi, setAdaKomplainRi] = useState(" Tidak Ada");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [showModal, setShowModal] = useState(false);
  const [riwayatData, setRiwayatData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showModalRencanaKontrol, setShowModalRencanaKontrol] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [showBackButton, setShowBackButton] = useState(false);
  const [serverTimeOffset, setServerTimeOffset] = useState(0);
  const getServerToday = () => moment(Date.now() + serverTimeOffset).startOf("day");
  const getServerNow = () => moment(Date.now() + serverTimeOffset);
  const [showConfirmCancel, setShowConfirmCancel] = useState(false);
  const [selectedNobooking, setSelectedNobooking] = useState(null);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const ALLOWED_KODEUNIT_BATAL = ["A62", "P48", "G16", "G17", "G18"];

  // === Auto-fill dari QR/barcode ===
  const [fromBarcode, setFromBarcode] = useState(false);

  const handleNextPage = () => {
    if (currentPage < Math.ceil(riwayatData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const paginatedData = riwayatData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const simpanReviewPelangganRjKomplain = () => {
    Axios.post(urlAPI + "/public/pelanggan/simpanReviewPelangganRjKomplain", {
      // noreg: paramPelanggan?.noreg,
      // jenis: paramPelanggan?.ketrawat,
      noreg: noReg?.noreg,
      jenis: noReg?.jenis == "R" ? "RAWIN" : "RAJAL",
      // nama: paramPelanggan?.nama,
      // unit: paramPelanggan?.tujuan,
      nama: dataPelanggan?.nama,
      unit: dataPelanggan?.tujuan,
      notlp: dataPelangganRajal?.notlp,
      no1: dataPelangganRajal?.no1,
      no2: dataPelangganRajal?.no2,
      no3: dataPelangganRajal?.no3,
      no4: dataPelangganRajal?.no4,
      no5: dataPelangganRajal?.no5,
      no6: dataPelangganRajal?.no6,
      no7: dataPelangganRajal?.no7,
      no8: dataPelangganRajal?.no8,
      no9: dataPelangganRajal?.no9,
      no10: dataPelangganRajal?.no10,
      no11: dataPelangganRajal?.no11,
      no12: dataPelangganRajal?.no12,
      promosi: dataPelangganRajal?.promosi,
      ketperawat: dataPelangganRajal?.perawat,
      apkes: dataPelangganRajal?.apkes,
      saran: dataPelangganRajal?.saran,
      keseluruhan: dataPelangganRajal?.keseluruhan,
      konfirmasi: dataPelangganRajal?.konfirmasi,
    })
      .then((res) => {
        if (res?.data?.status == true) {
          Swal.fire({
            title: "Berhasil!",
            text: "Terimakasih atas penilaian yang diberikan kepada kami!",
            icon: "success",
          }).then(function () {
            window.location.reload();
          });
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
        } else {
        }
      });
  };
  const simpanReviewPelangganRj = () => {
    Axios.post(urlAPI + "/public/pelanggan/simpanReviewPelangganRj", {
      // noreg: paramPelanggan?.noreg,
      // jenis: paramPelanggan?.ketrawat,
      noreg: noReg?.noreg,
      jenis: noReg?.jenis == "R" ? "RAWIN" : "RAJAL",
      // nama: paramPelanggan?.nama,
      // unit: paramPelanggan?.tujuan,
      nama: dataPelanggan?.nama,
      unit: dataPelanggan?.tujuan,
      notlp: dataPelangganRajal?.notlp,
      no1: dataPelangganRajal?.no1,
      no2: dataPelangganRajal?.no2,
      no3: dataPelangganRajal?.no3,
      no4: dataPelangganRajal?.no4,
      no5: dataPelangganRajal?.no5,
      no6: dataPelangganRajal?.no6,
      no7: dataPelangganRajal?.no7,
      no8: dataPelangganRajal?.no8,
      no9: dataPelangganRajal?.no9,
      no10: dataPelangganRajal?.no10,
      no11: dataPelangganRajal?.no11,
      no12: dataPelangganRajal?.no12,
      promosi: dataPelangganRajal?.promosi,
      ketperawat: dataPelangganRajal?.perawat,
      apkes: dataPelangganRajal?.apkes,
      saran: dataPelangganRajal?.saran,
      keseluruhan: dataPelangganRajal?.keseluruhan,
      konfirmasi: dataPelangganRajal?.konfirmasi,
    })
      .then((res) => {
        if (res?.data?.status == true) {
          Swal.fire({
            title:
              "Terimakasih Atas Kesediaan Anda Mengisi Kepuasan Pelanggan RSPG, Berkenan Memberi Penilaian Kami Di Google?",
            showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: "Bersedia",
            denyButtonText: `Tidak`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              Swal.fire("Bersedia", "", "success");
              const win = window.open("https://bit.ly/RateMe-RSPG", "_blank");
              win.focus();
              window.location.reload();
            } else if (result.isDenied) {
              Swal.fire("Tidak", "", "info");
              window.location.reload();
            }
          });
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
        } else {
        }
      });
  };

  const simpanReviewPelangganRiKomplain = () => {
    Axios.post(urlAPI + "/public/pelanggan/simpanReviewPelangganRiKomplain", {
      // noreg: paramPelanggan?.noreg,
      // jenis: paramPelanggan?.ketrawat,
      noreg: noReg?.noreg,
      jenis: noReg?.jenis == "R" ? "RAWIN" : "RAJAL",
      // nama: paramPelanggan?.nama,
      // unit: paramPelanggan?.tujuan,
      nama: dataPelanggan?.nama,
      unit: dataPelanggan?.tujuan,
      nokamar: dataPelangganRawin?.nokamar,
      notlp: dataPelangganRawin?.notlp,
      no1: dataPelangganRawin?.no1,
      no2: dataPelangganRawin?.no2,
      no3: dataPelangganRawin?.no3,
      no4: dataPelangganRawin?.no4,
      no5: dataPelangganRawin?.no5,
      no6: dataPelangganRawin?.no6,
      no7: dataPelangganRawin?.no7,
      no8: dataPelangganRawin?.no8,
      no9: dataPelangganRawin?.no9,
      no10: dataPelangganRawin?.no10,
      no11: dataPelangganRawin?.no11,
      no12: dataPelangganRawin?.no12,
      no13: dataPelangganRawin?.no13,
      no14: dataPelangganRawin?.no14,
      no15: dataPelangganRawin?.no15,
      no16: dataPelangganRawin?.no16,
      no17: dataPelangganRawin?.no17,
      no18: dataPelangganRawin?.no18,
      no19: dataPelangganRawin?.no19,
      no20: dataPelangganRawin?.no20,
      no21: dataPelangganRawin?.no21,
      no22: dataPelangganRawin?.no22,
      no23: dataPelangganRawin?.no23,
      no24: dataPelangganRawin?.no24,
      no25: dataPelangganRawin?.no25,
      no26: dataPelangganRawin?.no26,
      no27: dataPelangganRawin?.no27,
      no28: dataPelangganRawin?.no28,
      ketperawat: dataPelangganRawin?.perawat,
      apkes: dataPelangganRawin?.apkes,
      saran: dataPelangganRawin?.saran,
      keseluruhan: dataPelangganRawin?.keseluruhan,
      konfirmasi: dataPelangganRawin?.konfirmasi,
      promosi: dataPelangganRawin?.promosi,
    })
      .then((res) => {
        if (res?.data?.status == true) {
          Swal.fire({
            title: "Berhasil!",
            text: "Terimakasih atas penilaian yang diberikan kepada kami!",
            icon: "success",
          }).then(() => {
            window.location.reload(); // Refresh halaman setelah tombol "OK" di swal diklik
          });
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
        } else {
        }
      });
  };
  const simpanReviewPelangganRi = () => {
    Axios.post(urlAPI + "/public/pelanggan/simpanReviewPelangganRi", {
      // noreg: paramPelanggan?.noreg,
      // jenis: paramPelanggan?.ketrawat,
      noreg: noReg?.noreg,
      jenis: noReg?.jenis == "R" ? "RAWIN" : "RAJAL",
      // nama: paramPelanggan?.nama,
      // unit: paramPelanggan?.tujuan,
      nama: dataPelanggan?.nama,
      unit: dataPelanggan?.tujuan,
      nokamar: dataPelangganRawin?.nokamar,
      notlp: dataPelangganRawin?.notlp,
      no1: dataPelangganRawin?.no1,
      no2: dataPelangganRawin?.no2,
      no3: dataPelangganRawin?.no3,
      no4: dataPelangganRawin?.no4,
      no5: dataPelangganRawin?.no5,
      no6: dataPelangganRawin?.no6,
      no7: dataPelangganRawin?.no7,
      no8: dataPelangganRawin?.no8,
      no9: dataPelangganRawin?.no9,
      no10: dataPelangganRawin?.no10,
      no11: dataPelangganRawin?.no11,
      no12: dataPelangganRawin?.no12,
      no13: dataPelangganRawin?.no13,
      no14: dataPelangganRawin?.no14,
      no15: dataPelangganRawin?.no15,
      no16: dataPelangganRawin?.no16,
      no17: dataPelangganRawin?.no17,
      no18: dataPelangganRawin?.no18,
      no19: dataPelangganRawin?.no19,
      no20: dataPelangganRawin?.no20,
      no21: dataPelangganRawin?.no21,
      no22: dataPelangganRawin?.no22,
      no23: dataPelangganRawin?.no23,
      no24: dataPelangganRawin?.no24,
      no25: dataPelangganRawin?.no25,
      no26: dataPelangganRawin?.no26,
      no27: dataPelangganRawin?.no27,
      no28: dataPelangganRawin?.no28,
      ketperawat: dataPelangganRawin?.perawat,
      apkes: dataPelangganRawin?.apkes,
      saran: dataPelangganRawin?.saran,
      keseluruhan: dataPelangganRawin?.keseluruhan,
      konfirmasi: dataPelangganRawin?.konfirmasi,
      promosi: dataPelangganRawin?.promosi,
    })
      .then((res) => {
        if (res?.data?.status == true) {
          Swal.fire({
            title:
              "Terimakasih Atas Kesediaan Anda Mengisi Kepuasan Pelanggan RSPG, Berkenan Memberi Penilaian Kami Di Google?",
            showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: "Bersedia",
            denyButtonText: `Tidak`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              Swal.fire("Bersedia", "", "success");
              const win = window.open("https://bit.ly/RateMe-RSPG", "_blank");
              win.focus();
            } else if (result.isDenied) {
              Swal.fire("Tidak", "", "info");
            }
            window.location.reload();
          });
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
        } else {
        }
      });
  };

  const fetchListReg = () => {
    Axios.get(
      urlAPI +
        "/public/pelanggan/infoPelanggan?params=" +
        JSON.stringify({
          norm: paramPelanggan?.norm,
          tgllahir: paramPelanggan?.tgllahir,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          let tempAda = response?.data?.result?.count;
          let tempData = response?.data?.result?.rows;
          const selectorTempReg = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.noreg,
            label: obj?.noreg + " | " + obj?.tujuan + " | " + obj?.namaunit,
            name: obj?.noreg,
          }));
          setAdaData(tempAda);
          // setParamPelanggan(tempData);
          // setDataPelanggan(tempData);
          setSelectorReg(selectorTempReg);
          setLoadingReg(false);
        } else {
          setDataTable({ rows: [], count: 0 });
          setAdaData(null);
          setSelectorReg([]);
          setLoadingReg(false);
        }
        setLoadingLoad(false);
      })
      .catch((err) => {
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          // setShowFailed(true);
        } else {
          // setShowInfo(true);
        }
        setLoadingReg(false);
        setLoadingLoad(false);
      });
  };

  const fetchDataKunjungan = (overrideNoreg) => {
    const noregToUse =
      overrideNoreg ??
      (noReg?.noreg == null ? noReg?.noreg : noReg?.noreg.trim());

    Axios.get(
      urlAPI +
        "/public/pelanggan/dataKunjungan?params=" +
        JSON.stringify({
          noreg: noregToUse,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          // let tempAda = response?.data?.result?.count;
          let tempData = response?.data?.result?.rows[0];
          setDataPelanggan(tempData);
          // const selectorTempReg = response?.data?.result?.rows?.map((obj) => ({
          //   value: obj?.noreg,
          //   label: obj?.noreg +" | "+ obj?.tujuan +" | "+  obj?.namaunit,
          //   name: obj?.noreg,
          // }));
          // setAdaData(tempAda);
          // setSelectorReg(selectorTempReg)
          // setLoadingReg(false)
        } else {
          // setDataTable({ rows: [], count: 0 });
          // setAdaData(null);
          setSelectorReg([]);
          setLoadingReg(false);
        }
        setLoadingLoad(false);
      })
      .catch((err) => {
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          // setShowFailed(true);
        } else {
          // setShowInfo(true);
        }
        setLoadingReg(false);
        setLoadingLoad(false);
      });
  };

const fetchRiwayat = async () => {
  try {
    const response = await Axios.get(
      `${urlAPI}/public/pelanggan/infoRiwayat?params=${JSON.stringify({
        norm: paramPelanggan?.norm,
        tgllahir: paramPelanggan?.tgllahir,
      })}`
    );

    const data = response?.data?.result?.rows || [];

    if (Array.isArray(data) && data.length > 0) {
      setRiwayatData(
        data.map((row) => ({
          norm: row.NORM?.trim() || row.norm?.trim() || "",
          nama: row.NAMA?.trim() || row.nama?.trim() || "",
          kodeunit: row.KODEUNIT?.trim() || row.kodeunit?.trim() || "",
          namaunit: row.NAMAUNIT?.trim() || row.namaunit?.trim() || "",
          tglmasuk: row.TGLMASUK || row.tglmasuk || "",
          ket: row.KET || row.ket || "",
        }))
      );
      if (!paramPelanggan?.nama && data[0]?.nama) {
      setParamPelanggan((prev) => ({
          ...prev,
          nama: data[0].nama.trim(),
        }));
      }

      setShowModal(true);
    } else {
      setRiwayatData([]);
      setErrorMessage("Tidak Ada Riwayat Kunjungan Atau Data Yang Dimasukkan Salah!");
      setShowErrorModal(true);
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    setRiwayatData([]);
    setErrorMessage("Terjadi kesalahan saat mengambil data.");
    setShowErrorModal(true);
  }
};


// const fetchrencanaKontrol = async () => {
//   try {
//     const response = await Axios.get(
//       `${urlAPI}/public/pelanggan/rencanaKontrol?params=${JSON.stringify({
//         norm: paramPelanggan?.norm,
//         tgllahir: paramPelanggan?.tgllahir,
//       })}`
//     );

//     const serverDateHeader = response?.headers?.date;
//     if (serverDateHeader) {
//       const serverTime = new Date(serverDateHeader).getTime();
//       setServerTimeOffset(serverTime - Date.now());
//     }

//     const data = response?.data?.result?.rows || [];

//     if (Array.isArray(data) && data.length > 0) {
//       setRiwayatData(data.map((row) => ({
//         nobooking: row.nobooking || "",
//         tanggal: row.tanggal || "",
//         namaunit: row.namaunit || "",
//         kodeunit: row.kodeunit || "",
//         namadokter: row.namadokter || "",
//         ruang: row.ruang || "",
//         jam: row.jam || "",
//         noantrian: row.noantrian || "",
//         ket: row.ket || "",
//       })));
//       setShowModalRencanaKontrol(true);
//     } else {
//       setRiwayatData([]);
//       setErrorMessage("Tidak ada rencana kontrol");
//       setShowErrorModal(true);
//     }
//   } catch (err) {
//     console.error("Error fetching data:", err);
//     setRiwayatData([]);
//     setErrorMessage("Terjadi kesalahan saat mengambil data.");
//     setShowErrorModal(true);
//   }
// };

const fetchrencanaKontrol = async () => {
  try {
    const response = await Axios.get(
      `${urlAPI}/public/pelanggan/rencanaKontrol?params=${JSON.stringify({
        norm: paramPelanggan?.norm,
        tgllahir: paramPelanggan?.tgllahir,
      })}`
    );

    // Pakai waktu server (bukan jam perangkat pasien) untuk menentukan "hari ini"
    let offset = 0;
    const serverDateHeader = response?.headers?.date;
    if (serverDateHeader) {
      offset = new Date(serverDateHeader).getTime() - Date.now();
      setServerTimeOffset(offset);
    }
    const today = moment(Date.now() + offset).startOf("day");

    const data = response?.data?.result?.rows || [];

    // Buang rencana kontrol yang tanggalnya sudah lewat (sebelum hari ini).
    // Tanggal hari ini tetap ditampilkan.
    const aktif = data.filter((row) => {
      const tgl = moment(row.tanggal, "YYYY-MM-DD").startOf("day");
      return tgl.isValid() && !tgl.isBefore(today);
    });

    if (aktif.length > 0) {
      setRiwayatData(
        aktif.map((row) => ({
          nobooking: row.nobooking || "",
          tanggal: row.tanggal || "",
          namaunit: row.namaunit || "",
          kodeunit: row.kodeunit || "",
          namadokter: row.namadokter || "",
          ruang: row.ruang || "",
          jam: row.jam || "",
          noantrian: row.noantrian || "",
          ket: row.ket || "",
        }))
      );
      setShowModalRencanaKontrol(true);
    } else {
      setRiwayatData([]);
      setShowModalRencanaKontrol(false);
      setErrorMessage(
        "Saat ini tidak ada jadwal kontrol yang akan datang untuk pasien ini."
      );
      setShowErrorModal(true);
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    setRiwayatData([]);
    setErrorMessage("Terjadi kesalahan saat mengambil data.");
    setShowErrorModal(true);
  }
};

const handleConfirmCancel = async () => {
  if (!selectedNobooking) return;
  setLoadingCancel(true);
  try {
    const response = await Axios.post(
      `${urlAPI}/public/pelanggan/batalkanRencanaKontrol`,
      {
        nobooking: selectedNobooking,
        norm: paramPelanggan?.norm,
        tgllahir: paramPelanggan?.tgllahir,
      }
    );

    if (response?.data?.status === true) {
      setShowConfirmCancel(false);
      setSelectedNobooking(null);
      setRiwayatData((prev) =>
        prev.filter((item) => item.nobooking !== selectedNobooking)
      );

      Swal.fire({
        title: "Berhasil!",
        text: "Pendaftaran berhasil dibatalkan.",
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "Gagal",
        text: response?.data?.message || "Gagal membatalkan pendaftaran.",
        icon: "error",
      });
    }
  } catch (err) {
    console.error("Error membatalkan pendaftaran:", err);
    Swal.fire({
      title: "Gagal",
      text: "Terjadi kesalahan saat membatalkan pendaftaran.",
      icon: "error",
    });
  } finally {
    setLoadingCancel(false);
  }
};

const isBookingExpired = (row) => {
  const today = getServerNow().startOf("day");
  const tanggalBooking = moment(row.tanggal, "YYYY-MM-DD").startOf("day");
  if (tanggalBooking.isBefore(today)) {
    return true;
  }
  if (tanggalBooking.isAfter(today)) {
    return false;
  }
  const jamMulaiStr = row.jam?.split("-")[0]?.trim();
  if (!jamMulaiStr) {
    return false;
  }

  const cutoff = moment(
    `${row.tanggal} ${jamMulaiStr}`,
    "YYYY-MM-DD HH:mm"
  ).subtract(2, "hours");

  return getServerNow().isAfter(cutoff);
};

const isCancelAllowed = (row) => {
  const kode = (row?.kodeunit || row?.nobooking?.substring(0, 3) || "")
    .trim()
    .toUpperCase();
  return ALLOWED_KODEUNIT_BATAL.includes(kode);
};
// const fetchbillingPerawatan = async () => {
//   try {
//     const response = await Axios.get(
//       `${urlAPI}/public/pelanggan/billingperawatan?params=${JSON.stringify({
//         norm: paramPelanggan?.norm,
//         tgllahir: paramPelanggan?.tgllahir,
//       })}`
//     );

//     const data = response?.data?.result?.rows || [];

//     if (Array.isArray(data) && data.length > 0) {
//       setRiwayatData(data.map(row => ({
//         nobooking: row.nobooking || "",
//         tglmasuk: row.TGLMASUK || row.tglmasuk || "",
//         kodeunit: row.KODEUNIT?.trim() || row.kodeunit?.trim() || "",
//         namaunit: row.NAMAUNIT?.trim() || row.namaunit?.trim() || "",
//         namadokter: row.namadokter || "",
//         ruang: row.ruang || "",
//         jam: row.jam || "",
//         ket: row.ket || "",
//       })));
//       setShowModalBilling(true);
//     } else {
//       setRiwayatData([]);
//       setErrorMessage("Tidak ada billing perawatan");
//       setShowErrorModal(true);
//     }
//   } catch (err) {
//     console.error("Error fetching data:", err);
//     setRiwayatData([]);
//     setErrorMessage("Terjadi kesalahan saat mengambil data.");
//     setShowErrorModal(true);
//   }
// };


  const handleDownload = (nobooking) => {
    history.push(`/ticket/${nobooking}/blue`);
    setShowModalRencanaKontrol(false);
    // setShowModalBilling(false);
    setShowBackButton(true);
  };

  const handleBack = () => {
    history.push(`/`);
  };


  const fetchCariData = () => {
    Axios.get(
      urlAPI +
        "/public/antrian/caridata?params=" +
        JSON.stringify({
          NOBOOKING: idbook,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const tempData = response?.data?.result?.rows[0];
          setDataBooking({
            NOBOOKING: tempData?.nobooking,
            PASIEN: tempData?.pasien,
            FARMASI: tempData?.farmasi,
            RADIOLOGI: tempData?.radiologi,
            LABORATORIUM: tempData?.laboratorium,
            TUJUAN: tempData?.tujuan,
            NAMAUNIT: tempData?.namaunit,
          });
          //setLoadingCari(false);
        } else {
          setLoadingCari(false);
        }
      })
      .catch((err) => {
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          setShowFailed(true);
        } else {
          setShowInfo(true);
        }

        setLoadingLoad(false);
      });
  };
  /*eslint-disable */

  // === Baca query string dari URL hasil scan QR/barcode ===
  // Contoh URL: http://daftaronline.rspg-group.com/?menu=kuisioner&sbu=RSPG&norm=721803&tgllahir=2001-04-11&noreg=R202607010023
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const qNorm = searchParams.get("norm");
    const qTglLahir = searchParams.get("tgllahir");
    const qNoreg = searchParams.get("noreg");

    if (qNorm && qTglLahir) {
      setFromBarcode(true);

      setParamPelanggan({
        nama: null,
        norm: qNorm,
        tgllahir: qTglLahir,
      });

      if (qNoreg) {
        setNoReg({
          noreg: qNoreg,
          jenis: qNoreg.substring(0, 1),
        });
        // setAdaData(false); // skip langkah "Pilih No Registrasi"
        fetchDataKunjungan(qNoreg);
      }

      setIsSubmitted(true);
    }
  }, []);

  useEffect(() => {
    fetchListReg();
    fetchDataKunjungan();
    if (filterAntrian?.sbu !== null) {
      setLoadingAntrian(true);
      setLoadingReg(true);
    }
  }, [noReg]);

  useEffect(() => {
  if (fromBarcode && isSubmitted && paramPelanggan?.norm && paramPelanggan?.tgllahir) {
    if (source === "Riwayat") fetchRiwayat();
    else if (source === "RencanaKontrol") fetchrencanaKontrol();
  }
}, [fromBarcode, isSubmitted, paramPelanggan, source]);
  useEffect(() => {
    if (riwayatData.length > 0 && source === "Riwayat") {
      setShowModal(true);
    } else if (riwayatData.length > 0 && source === "RencanaKontrol") {
      setShowModalRencanaKontrol(true);
    }
  }, [riwayatData, source]);
  return (
    <>
      <Card>
        <Card.Body>
          <Form>
            <Row>
              <Col lg="12" md="12" sm="12">
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlInput1"
                  >
                  <Form.Label sm={true}>
                    {source === "Pelanggan" ? "NORM / NIK" : "NORM"}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={
                      source === "Pelanggan"
                        ? "Masukkan No Rekam Medis / NIK KTP"
                        : "Masukkan No Rekam Medis"
                    }
                    size="sm"
                    value={paramPelanggan?.norm || ""}
                    onChange={(e) =>
                      setParamPelanggan({
                        ...paramPelanggan,
                        norm: e.target.value,
                      })
                    }
                    disabled={fromBarcode}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg="12" md="12" sm="12">
                <Form.Group
                 className="mb-2"
                  controlId="exampleForm.ControlInput1">
                  <Form.Label>Tanggal Lahir</Form.Label>
                  <Form.Control
                    type="date"
                    size="sm"
                    placeholder="dd/mm/yyyy"
                    value={paramPelanggan?.tgllahir || ""}
                    onChange={(e) =>
                      setParamPelanggan({
                        ...paramPelanggan,
                        tgllahir: e.target.value,
                      })
                    }
                    disabled={fromBarcode}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>

          {!fromBarcode && (
            <Row>
              <Col lg="12" md="12" sm="12">
                <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                  <Button
                    block
                    onClick={async () => {
                      setIsSubmitted(true);

                      if (source === "Pelanggan") {
                        fetchListReg();
                        setAdaData(true);
                      } else if (source === "Riwayat") {
                        setAdaData(false);
                        setShowModal(false);
                        await fetchRiwayat();
                      } else if (source === "Pengaduan") {
                        setAdaData(false);
                        fetchDataPengaduan();
                        setShowModal(false);
                      } else if (source === "RencanaKontrol") {
                        await fetchrencanaKontrol();
                        // setShowModalRencanaKontrol(true);
                      } else if (source === "Billing") {
                        await fetchbillingPerawatan();
                        setShowModalBilling(true);
                      }
                    }}
                    disabled={
                      paramPelanggan?.norm === "" ||
                      paramPelanggan?.tgllahir === ""
                    }
                    style={{
                      background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                      border: "none",
                      color: "#fff",
                    }}
                  >
                    Lanjutkan
                  </Button>
                </div>
              </Col>
              <Col lg="6" md="6" sm="12"></Col>
            </Row>
          )}

          {adaData &&
          source !== "Riwayat" &&
          source !== "Pengaduan" &&
          !fromBarcode ? (
            <Row>
              <Col lg="12" md="12" sm="12">
                <Form.Group className="mb-3">
                  <div className="text-center fw-bold mt-3 mb-2">
                    {" "}
                    Pilih No Registrasi{" "}
                  </div>
                  <Select
                    styles={{
                      color: "black",
                      zIndex: 99999,
                    }}
                    id="unit"
                    name="unit"
                    options={selectorReg}
                    isLoading={loadingReg}
                    value={selectorReg.find(
                      (find) => find?.value === noReg?.noreg
                    )}
                    onChange={(e) => {
                      const noregTerpilih = e.value;
                      setNoReg({
                        ...noReg,                                                         
                        jenis: noregTerpilih.substring(0, 1),
                        noreg: noregTerpilih,
                      });
                      fetchDataKunjungan(noregTerpilih);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          ) : null}

          <Modal show={showModal} onHide={() => setShowModal(false)} centered scrollable size="lg">
            <Modal.Header closeButton className="bg-white text-black">
              <Modal.Title className="fw-bold">Riwayat Kunjungan</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
              <div className="d-flex flex-column align-items-center">
                <div
                  className="card rounded-3 shadow-lg border-0 w-100"
                  style={{ maxWidth: "800px" }}
                >
                  <div className="card-header bg-warning text-dark text-center fw-bold">
                    Informasi Pasien
                  </div>
                  <div className="card-body bg-white text-dark">
                    <div className="d-grid gap-1">
                      <div className="d-flex">
                        <strong className="flex-grow-1">Nama :</strong>
                        <span>
                          {paramPelanggan?.nama?.trim() ||
                            riwayatData[0]?.nama?.trim() ||
                            "Tidak tersedia"}
                        </span>
                      </div>
                      <div className="d-flex">
                        <strong className="flex-grow-1">No. RM :</strong>
                        <span>{paramPelanggan?.norm || "Tidak tersedia"}</span>
                      </div>
                      <div className="d-flex">
                        <strong className="flex-grow-1">
                          Tanggal Lahir :
                        </strong>
                        <span>
                          {paramPelanggan?.tgllahir
                            ? moment(paramPelanggan.tgllahir).format(
                                "DD/MM/YYYY"
                              )
                            : "Tidak tersedia"}
                        </span>
                      </div>
                      <div className="d-flex">
                        <strong className="flex-grow-1">
                          Total Kunjungan :
                        </strong>
                        <span>{riwayatData.length} Kunjungan</span>
                      </div>
                    </div>
                  </div>
                </div>
                {riwayatData?.length > 0 ? (
                  <div
                    className="table-responsive mt-4 w-100"
                    style={{ maxWidth: "800px" }}
                  >
                    <Table
                      striped
                      bordered
                      hover
                      className="text-left align-middle shadow-sm"
                    >
                      <thead
                        style={{ backgroundColor: "#4cb050", color: "white" }}
                      >
                        <tr>
                          <th>No</th>
                          <th>Tanggal</th>
                          <th>Poli</th>
                          <th>SBU</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData
                          .sort(
                            (a, b) =>
                              new Date(b.tglmasuk) - new Date(a.tglmasuk)
                          )
                          .map((row, index) => (
                            <tr key={index}>
                              <td>
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>
                                {moment(row.tglmasuk).format("DD/MM/YYYY")}
                              </td>
                              <td>{row.namaunit}</td>
                              <td>{row.ket}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-end w-100">
                      <Button
                        variant="secondary"
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="me-2"
                      >
                        Previous
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={handleNextPage}
                        disabled={
                          currentPage ===
                          Math.ceil(riwayatData.length / itemsPerPage)
                        }
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="text-center p-4">
                    <p className="text-danger fw-bold">{errorMessage}</p>
                    <Button
                      variant="secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Tutup
                    </Button>
                  </div>
                )}
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showModalRencanaKontrol}
            onHide={() => setShowModalRencanaKontrol(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Rencana Kontrol</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mt-3">
                {riwayatData.map((row, index) => {
                const isExpired = isBookingExpired(row);
                const canCancel = isCancelAllowed(row);

                return (
                  <Col lg={6} md={6} sm={12} key={index} className="mb-4">
                    <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <div className="text-center bg-warning p-2 rounded fw-bold mb-3">
                          No Booking : {row.nobooking}
                        </div>
                        <Card.Text>
                          <Row className="small text-muted">
                            <Col xs={5} className="fw-bold border-bottom py-1">
                              Tanggal
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.tanggal}
                            </Col>

                            <Col xs={5} className="fw-bold border-bottom py-1">
                              Nama Unit
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.namaunit}
                            </Col>

                            <Col xs={5} className="fw-bold border-bottom py-1">
                              Nama Dokter
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.namadokter}
                            </Col>

                            <Col xs={5} className="fw-bold border-bottom py-1">
                              Ruang
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.ruang}
                            </Col>

                            <Col xs={5} className="fw-bold border-bottom py-1">
                              Jam
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.jam}
                            </Col>

                            <Col xs={5} className="fw-bold border-bottom py-1">
                              No Antrian
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.noantrian}
                            </Col>

                            <Col xs={5} className="fw-bold border-bottom py-1">
                              Tujuan
                            </Col>
                            <Col xs={7} className="border-bottom py-1">
                              : {row.ket}
                            </Col>
                          </Row>
                        </Card.Text>
                        <Button
                          variant="success"
                          className="w-100 d-flex align-items-center justify-content-center gap-2 mt-3"
                          onClick={() => handleDownload(row.nobooking)}
                        >
                          <Icons.FileText size={18} /> Download Tiket
                        </Button>
                      {canCancel && (
                          <Button
                            variant="danger"
                            className="w-100 d-flex align-items-center justify-content-center gap-2 mt-3"
                            onClick={() => {
                              setSelectedNobooking(row.nobooking);
                              setShowConfirmCancel(true);
                            }}
                            disabled={isExpired}
                          >
                            <Icons.X size={18} /> Batalkan Pendaftaran
                          </Button>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
              </Row>
            </Modal.Body>
          </Modal>
          <Modal
            show={showConfirmCancel}
            onHide={() => {
              if (!loadingCancel) {
                setShowConfirmCancel(false);
                setSelectedNobooking(null);
              }
            }}
            centered
          >
            <Modal.Header closeButton={!loadingCancel}>
              <Modal.Title>Konfirmasi Pembatalan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="mb-0">
                Apakah Anda yakin ingin membatalkan pendaftaran dengan No Booking{" "}
                <strong>{selectedNobooking}</strong>?
              </p>
              <p className="text-muted mt-2 mb-0" style={{ fontSize: "13px" }}>
                Tindakan ini tidak dapat dibatalkan.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowConfirmCancel(false);
                  setSelectedNobooking(null);
                }}
                disabled={loadingCancel}
              >
                Tidak
              </Button>
              <Button
                variant="danger"
                onClick={handleConfirmCancel}
                disabled={loadingCancel}
              >
                {loadingCancel ? "Memproses..." : "Ya, Batalkan"}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showErrorModal}
            onHide={() => setShowErrorModal(false)}
            centered
            size="sm"
            style={{
              zIndex: 1075,
              backgroundColor: "rgba(0,0,0,0.5)",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
            }}
          >
            <Modal.Body className="text-center p-4">
              <div
                className="d-flex align-items-center justify-content-center mx-auto mb-3"
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                  color: "#fff",
                }}
              >
                <Icons.Calendar size={30} />
              </div>
              <h5 className="fw-bold mb-2" style={{ color: "#2e7d32" }}>
                Informasi
              </h5>
              <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
                {errorMessage}
              </p>
              <Button
                className="w-100"
                onClick={() => setShowErrorModal(false)}
                style={{
                  background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                  border: "none",
                  color: "#fff",
                }}
              >
                Mengerti
              </Button>
            </Modal.Body>
          </Modal>

          <>
            {noReg?.jenis == "R" ? (
              <>
                <hr />
                <Form>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>Nama</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <b>: {dataPelanggan?.nama}</b>
                    </Col>
                  </Row>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>Rawat Inap Di</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <b>: {dataPelanggan?.namaunit}</b>
                    </Col>
                  </Row>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>Kamar No</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                        onChange={(e) =>
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            nokamar: e.target.value,
                          })
                        }
                      >
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Masukkan No Kamar"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>No Tlp</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                        onChange={(e) =>
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            notlp: e.target.value,
                          })
                        }
                      >
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Masukkan No Tlp"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <hr />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      1. Pendaftaran Rawat Inap
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin1"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no1: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin1"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no1: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin1"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no1: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin1"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no1: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      2. Dokter Spesialis melakukan pemeriksaan & menjelaskan
                      kondisi kesehatan dengan baik
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin2"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no2: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin2"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no2: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin2"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no2: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin2"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no2: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      3. Dokter Jaga Ruangan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin3"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no3: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin3"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no3: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin3"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no3: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin3"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no3: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      4. Perawat selalu memperkenalkan diri
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin4"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no4: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin4"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no4: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin4"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no4: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin4"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no4: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      5. Perawat selalu memberi salam dan senyum ketika
                      bertemu dengan anda
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin5"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no5: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin5"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no5: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin5"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no5: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin5"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no5: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      6. Perawat memberikan informasi tentang fasilitas yang
                      tersedia, cara penggunaanya dan tata tertib yang berlaku
                      di RS
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin6"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no6: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin6"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no6: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin6"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no6: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin6"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no6: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      7. Perawat memberitahu dengan jelas tentang hal – hal
                      yang harus dipatuhi dan dilarang dalam perawatan Anda
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin7"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no7: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin7"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no7: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin7"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no7: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin7"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no7: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      8. Perawat memberikan edukasi kepada pasien dan keluarga
                      tentang cara cuci tangan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin8"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no8: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin8"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no8: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin8"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no8: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin8"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no8: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      9. Ketepatan waktu perawat tiba diruangan ketika anda
                      membutuhkan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin9"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no9: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin9"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no9: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin9"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no9: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin9"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no9: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      10. Perawat segera menangani anda ketika sampai di
                      ruangan Rawat Inap
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin10"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no10: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin10"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no10: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin10"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no10: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin10"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no10: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      11. Perawat memberi perhatian terhadap keluhan yang
                      Anda rasakan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin11"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no11: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin11"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no11: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin11"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no11: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin11"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no11: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      12. Perawat memberikan informasi kepada Anda tentang
                      segala tindakan perawatan yang dilaksanakan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin12"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no12: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin12"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no12: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin12"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no12: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin12"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no12: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      13. Perawat sering menengok dan memeriksa keadaan Anda
                      seperti mengukur tensi, suhu, nadi, pernafasan dan
                      cairan infus
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin13"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no13: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin13"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no13: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin13"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no13: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin13"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no13: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      14. Pelayanan petugas apoteker
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin14"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no14: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin14"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no14: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin14"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no14: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin14"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no14: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      15. Ketepatan Jadwal pemberian obat per hari
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin15"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no15: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin15"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no15: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin15"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no15: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin15"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no15: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      16. Kenyamanan ruang perawatan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin16"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no16: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin16"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no16: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin16"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no16: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin16"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no16: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      17. Kenyamanan fasilitas RS yang lain (Ruang tunggu,
                      toilet, tempat ibadah)
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin17"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no17: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin17"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no17: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin17"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no17: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin17"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no17: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      18. Kemudahan mendapatkan informasi selama di RS
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin18"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no18: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin18"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no18: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin18"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no18: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin18"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no18: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      19. Keamanan selama Rawat Inap di RS
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin19"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no19: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin19"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no19: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin19"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no19: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin19"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no19: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      20. Pelayanan petugas gizi (ahli gizi, penyaji)
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin20"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no20: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin20"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no20: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin20"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no20: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin20"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no20: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      21. Variasi rasa dan menu makanan yang di tawarkan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin21"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no21: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin21"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no21: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin21"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no21: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin21"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no21: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      22. Petugas kebersihan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin22"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no22: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin22"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no22: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin22"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no22: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin22"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no22: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      23. Kecepatan adminitrasi pasien pulang
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin23"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no23: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin23"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no23: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin23"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no23: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin23"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no23: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      24. Pelayanan (obat, laboratorium/tindakan medis) tanpa
                      biaya tambahan DILUAR KETENTUAN{" "}
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin24"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no24: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin24"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no24: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin24"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no24: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin24"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no24: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      25. Petugas memberikan layanan tanpa membedakan pasien
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin25"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no25: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin25"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no25: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin25"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no25: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin25"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no25: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      26. Bagaimana proses penanganan pengaduan, saran dan
                      masukan terhadap layanan di RS ini?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin26"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no26: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin26"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no26: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin26"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no26: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin26"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no26: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      27. Bagaimana pelayanan laboratorium?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin27"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no27: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin27"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no27: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin27"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no27: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin27"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no27: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      28. Bagaimana pelayanan radiologi?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rawin28"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no28: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rawin28"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no28: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rawin28"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no28: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rawin28"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            no28: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      Apakah anda bersedia mempromosikan Rumah Sakit ini ke
                      orang-orang sekitar anda?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Tidak Merekomendasikan (0-6)"
                        color="info"
                        name="rawinpromosi"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            promosi: "Tidak Merekomendasikan (0-6)",
                          });
                        }}
                      />
                      <Radio
                        label=" Biasa (7-8)"
                        color="info"
                        name="rawinpromosi"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            promosi: "Biasa (7-8)",
                          });
                        }}
                      />
                      <Radio
                        label=" Merekomendasikan (9-10)"
                        color="info"
                        name="rawinpromosi"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            promosi: "Merekomendasikan (9-10)",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      Secara keseluruhan, menurut anda bagaimana proses
                      pelayanan yang diberikan oleh unit pelayanan ini?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Tidak Baik"
                        color="info"
                        name="rawinKeseluruhan"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            keseluruhan: "Tidak Baik",
                          });
                        }}
                      />
                      <Radio
                        label=" Baik"
                        color="info"
                        name="rawinKeseluruhan"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            keseluruhan: "Baik",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      Apakah anda berkenan untuk dikonfirmasi ulang?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Tidak"
                        color="info"
                        name="rajalKonfirmasi"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            konfirmasi: "Tidak",
                          });
                        }}
                      />
                      <Radio
                        label=" Ya"
                        color="info"
                        name="rajalKonfirmasi"
                        onClick={() => {
                          setDataPelangganRawin({
                            ...dataPelangganRawin,
                            konfirmasi: "Ya",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group
                      className="mb-2"
                      onChange={(e) =>
                        setDataPelangganRawin({
                          ...dataPelangganRawin,
                          perawat: e.target.value,
                        })
                      }
                    >
                      <Form.Label className="fs-6 fw-bold">
                        Nama Perawat Yang Dikenal
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        size="sm"
                        style={{ width: "100%" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group
                      className="mb-2"
                      onChange={(e) =>
                        setDataPelangganRawin({
                          ...dataPelangganRawin,
                          apkes: e.target.value,
                        })
                      }
                    >
                      <Form.Label className="fs-6 fw-bold">
                        Apresiasi/Masukan Terhadap Pelayanan Di Rumah Sakit
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        placeholder=""
                        size="sm"
                        style={{ width: "100%" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group
                      className="mb-2"
                      onChange={(e) =>
                        setDataPelangganRawin({
                          ...dataPelangganRawin,
                          saran: e.target.value,
                        })
                      }
                    >
                      <Form.Label className="fs-6 fw-bold">
                        Saran/masukan untuk perbaikan pelayanan Rumah Sakit
                      </Form.Label>
                      <Radio
                        label=" Tidak Ada"
                        color="info"
                        name="adaKomplainRi"
                        onClick={() => {
                          setAdaKomplainRi(" Tidak Ada");
                        }}
                        checked={adaKomplainRi == " Tidak Ada"}
                      />
                      <Radio
                        label=" Ada"
                        color="info"
                        name="adaKomplainRi"
                        onClick={() => {
                          setAdaKomplainRi(" Ada");
                        }}
                        checked={adaKomplainRi === " Ada"}
                      />
                      <Form.Control
                        as="textarea"
                        placeholder=""
                        size="sm"
                        disabled={adaKomplainRi == " Tidak Ada"}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <div
                      className="d-grid gap-2"
                      style={{ paddingTop: "32px" }}
                    >
                      {dataPelangganRawin?.saran == null ||
                      dataPelangganRawin?.saran == "" ? (
                        <Button
                          block
                          variant="success"
                          onClick={() => {
                            simpanReviewPelangganRi();
                          }}
                        >
                          Simpan
                        </Button>
                      ) : (
                        <Button
                          block
                          variant="success"
                          onClick={() => {
                            simpanReviewPelangganRiKomplain();
                          }}
                        >
                          Simpan
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col lg="6" md="6" sm="12"></Col>
                </Row>
              </>
            ) : noReg?.jenis == "2" ? (
              <>
                <hr />
                <Form>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>Nama</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <b>: {dataPelanggan?.nama}</b>
                    </Col>
                  </Row>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>Kunjungan Di Poli</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <b>: {dataPelanggan?.namaunit}</b>
                    </Col>
                  </Row>
                  <Row className="align-items-center mb-3">
                    <Col lg="3" md="4" sm="12" className="mb-2">
                      <b>No Tlp</b>
                    </Col>
                    <Col lg="9" md="8" sm="12">
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                        onChange={(e) =>
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            notlp: e.target.value,
                          })
                        }
                      >
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Masukkan No Tlp"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>

                <hr />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      1. Pendaftaran
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal1"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no1: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal1"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no1: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal1"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no1: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal1"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no1: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      2. Kemudahan memperoleh informasi terkait pelayanan di
                      Rumah Sakit
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal2"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no2: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal2"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no2: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal2"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no2: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal2"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no2: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      3. Petugas sigap dalam memberikan pelayanan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal3"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no3: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal3"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no3: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal3"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no3: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal3"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no3: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      4. Petugas memberikan layanan tanpa membedakan pasien
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal4"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no4: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal4"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no4: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal4"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no4: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal4"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no4: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      5. Dokter melakukan pemeriksaan & menjelaskan kondisi
                      kesehatan dengan baik
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal5"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no5: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal5"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no5: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal5"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no5: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal5"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no5: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      6. Kecepatan antrian layanan obat/farmasi (bagi yang
                      mendapat resep/obat)
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal6"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no6: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal6"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no6: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal6"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no6: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal6"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no6: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      7. Kecepatan layanan laboratorium (bagi pasien yang
                      disarankan untuk Lab.)
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal7"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no7: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal7"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no7: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal7"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no7: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal7"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no7: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      8. Kecepatan layanan radiologi (bagi pasien yang
                      disarankan untuk Rad.)
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal8"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no8: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal8"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no8: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal8"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no8: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal8"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no8: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      9. Kenyamanan dan Kebersihan
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal9"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no9: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal9"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no9: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal9"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no9: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal9"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no9: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      10. Petugas (Dokter/Perawat/Farmasi/Administrasi)
                      memberikan pelayanan dengan baik & ramah
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal10"
                        onClick={() =>
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no10: "1",
                          })
                        }
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal10"
                        onClick={() =>
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no10: "2",
                          })
                        }
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal10"
                        onClick={() =>
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no10: "3",
                          })
                        }
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal10"
                        onClick={() =>
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no10: "4",
                          })
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      11. Keramahan petugas satpam/security
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal11"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no11: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal11"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no11: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal11"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no11: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal11"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no11: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      12. Pelayanan (obat, laboratorium/tindakan medis) tanpa
                      biaya tambahan DILUAR KETENTUAN
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Sangat Tidak Puas"
                        color="info"
                        name="rajal12"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no12: "1",
                          });
                        }}
                      />
                      <Radio
                        label=" Tidak Puas"
                        color="info"
                        name="rajal12"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no12: "2",
                          });
                        }}
                      />
                      <Radio
                        label=" Puas"
                        color="info"
                        name="rajal12"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no12: "3",
                          });
                        }}
                      />
                      <Radio
                        label=" Sangat Puas"
                        color="info"
                        name="rajal12"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            no12: "4",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      Apakah anda bersedia mempromosikan Rumah Sakit ini ke
                      orang-orang sekitar anda?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Tidak Merekomendasikan (0-6)"
                        color="info"
                        name="rajalpromosi"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            promosi: "Tidak Merekomendasikan (0-6)",
                          });
                        }}
                      />
                      <Radio
                        label=" Biasa (7-8)"
                        color="info"
                        name="rajalpromosi"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            promosi: "Biasa (7-8)",
                          });
                        }}
                      />
                      <Radio
                        label=" Merekomendasikan (9-10)"
                        color="info"
                        name="rajalpromosi"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            promosi: "Merekomendasikan (9-10)",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      Secara keseluruhan, menurut anda bagaimana proses
                      pelayanan yang diberikan oleh unit pelayanan ini?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Tidak Baik"
                        color="info"
                        name="rajalKeseluruhan"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            keseluruhan: "Tidak Baik",
                          });
                        }}
                      />
                      <Radio
                        label=" Baik"
                        color="info"
                        name="rajalKeseluruhan"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            keseluruhan: "Baik",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row className="align-items-start mb-3">
                  <Col lg="3" md="4" sm="12" className="mb-2">
                    <label className="fw-bold d-block">
                      Apakah anda berkenan untuk dikonfirmasi ulang?
                    </label>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                      <Radio
                        label=" Tidak"
                        color="info"
                        name="rajalKonfirmasi"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            konfirmasi: "Tidak",
                          });
                        }}
                      />
                      <Radio
                        label=" Ya"
                        color="info"
                        name="rajalKonfirmasi"
                        onClick={() => {
                          setDataPelangganRajal({
                            ...dataPelangganRajal,
                            konfirmasi: "Ya",
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group
                      className="mb-2"
                      onChange={(e) =>
                        setDataPelangganRajal({
                          ...dataPelangganRajal,
                          perawat: e.target.value,
                        })
                      }
                    >
                      <Form.Label className="fs-6 fw-bold">
                        Nama Petugas Yang Dikenal
                      </Form.Label>
                      <Form.Control
                        type="textarea"
                        placeholder=""
                        size="sm"
                        style={{ width: "100%" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group
                      className="mb-2"
                      onChange={(e) =>
                        setDataPelangganRajal({
                          ...dataPelangganRajal,
                          apkes: e.target.value,
                        })
                      }
                    >
                      <Form.Label className="fs-6 fw-bold">
                        Apresiasi/Masukan Terhadap Pelayanan Di Rumah Sakit
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        placeholder=""
                        size="sm"
                        style={{ width: "100%" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group
                      className="mb-2"
                      onChange={(e) =>
                        setDataPelangganRajal({
                          ...dataPelangganRajal,
                          saran: e.target.value,
                        })
                      }
                    >
                      <Form.Label className="fs-6 fw-bold">
                        Komplain Atau Pengaduan Layanan
                      </Form.Label>
                      <Col lg="12" md="12" sm="12">
                        <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
                          <Radio
                            label=" Tidak Ada"
                            color="info"
                            name="adaKomplain"
                            onClick={() => {
                              setAdaKomplain(" Tidak Ada");
                            }}
                            checked={adaKomplain == " Tidak Ada"}
                          />
                          <Radio
                            label=" Ada"
                            color="info"
                            name="adaKomplain"
                            onClick={() => {
                              setAdaKomplain(" Ada");
                            }}
                            checked={adaKomplain === " Ada"}
                          />
                          <Form.Control
                            as="textarea"
                            placeholder=""
                            size="sm"
                            disabled={adaKomplain == " Tidak Ada"}
                          />
                        </div>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <div
                      className="d-grid gap-2"
                      style={{ paddingTop: "32px" }}
                    >
                      {(adaKomplain == " Tidak Ada" &&
                        dataPelangganRajal?.saran == null) ||
                      dataPelangganRajal?.saran == "" ? (
                        <Button
                          block
                          style={{
                            background:
                              "linear-gradient(90deg, #17c3b2, #1890ff, #0052d4)",
                            border: "none",
                            color: "#fff",
                          }}
                          onClick={() => {
                            simpanReviewPelangganRj();
                          }}
                        >
                          Simpan
                        </Button>
                      ) : (
                        <Button
                          block
                          style={{
                            background:
                              "linear-gradient(90deg, #17c3b2, #1890ff, #0052d4)",
                            border: "none",
                            color: "#fff",
                          }}
                          onClick={() => {
                            simpanReviewPelangganRjKomplain();
                          }}
                        >
                          Simpan
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col lg="6" md="6" sm="12"></Col>
                </Row>
              </>
            ) : (
              <></>
            )}
          </>
        </Card.Body>
      </Card>
    </>
  );
}